"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var caret_down_1 = require("adp-react-icons/lib/fa/caret-down");
var react_overlays_1 = require("../react-overlays");
var LeftNavItem = /** @class */ (function (_super) {
    __extends(LeftNavItem, _super);
    function LeftNavItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expanded: _this.props.item.expanded || false
        };
        _this.handleClick = function (event) {
            var _a = _this.props, onSelect = _a.onSelect, item = _a.item, onClick = _a.onClick;
            var hasChildren = item.items && item.items.length;
            event.stopPropagation();
            if (hasChildren) {
                var expanded = !_this.state.expanded;
                // Make sure the expanded state gets passed back to the application by setting it in the item.
                item.expanded = expanded;
                _this.setState({ expanded: expanded });
            }
            if (onClick) {
                onClick(item);
            }
            if (!hasChildren) {
                onSelect(item);
            }
        };
        return _this;
    }
    LeftNavItem.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.item && (newProps.item.expanded !== this.state.expanded)) {
            this.setState({
                expanded: newProps.item.expanded
            });
        }
    };
    LeftNavItem.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, selectedItem = _b.selectedItem, item = _b.item, onSelect = _b.onSelect;
        var hasChildren = !!(item.items && item.items.length);
        var navItemClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('left-nav__item')] = true,
            _a[vdl_prefix_1.vdlPrefix('left-nav__item--selected')] = item === selectedItem && !hasChildren,
            _a[vdl_prefix_1.vdlPrefix('left-nav__item--has-children')] = hasChildren,
            _a[vdl_prefix_1.vdlPrefix('left-nav__item--expanded')] = hasChildren && this.state.expanded,
            _a[vdl_prefix_1.vdlPrefix('left-nav__item--collapsed')] = hasChildren && !this.state.expanded,
            _a);
        return (React.createElement("div", { className: classnames_1.classNames(navItemClasses), onClick: this.handleClick },
            React.createElement("label", { className: vdl_prefix_1.vdlPrefix('left-nav__item__label') },
                hasChildren &&
                    React.createElement(caret_down_1.default, { className: vdl_prefix_1.vdlPrefix('left-nav__item__expand-icon') }),
                item.label),
            hasChildren &&
                React.createElement("div", { className: vdl_prefix_1.vdlPrefix('left-nav__item__scrollbox') },
                    React.createElement(react_overlays_1.Transition, { in: this.state.expanded, timeout: 300, enteredClassName: vdl_prefix_1.vdlPrefix('left-nav__item__items--expanded'), enteringClassName: vdl_prefix_1.vdlPrefix('left-nav__item__items--expanding'), exitedClassName: vdl_prefix_1.vdlPrefix('left-nav__item__items--collapsed'), exitingClassName: vdl_prefix_1.vdlPrefix('left-nav__item__items--collapsing') },
                        React.createElement("div", { className: vdl_prefix_1.vdlPrefix('left-nav__item__items') }, item.items.map(function (item, index) { return (React.createElement(LeftNavItem, { key: index, item: item, selectedItem: selectedItem, onSelect: onSelect, onClick: _this.props.onClick })); }))))));
    };
    LeftNavItem.propTypes = {
        item: PropTypes.object.isRequired,
        selectedItem: PropTypes.object,
        onSelect: PropTypes.func.isRequired,
        onClick: PropTypes.func
    };
    return LeftNavItem;
}(React.Component));
exports.LeftNavItem = LeftNavItem;
